import script from "./FilterChipsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterChipsBar.vue?vue&type=script&setup=true&lang=js"

import "./FilterChipsBar.vue?vue&type=style&index=0&id=60eed303&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60eed303"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
